export const SITE_NAME = "パラシトスシンドローム";
